export const downloadFile = (url: string) => {
    const link = document.createElement('a') as HTMLAnchorElement;
    link.href = url;
    link.click();
    link.parentNode?.removeChild(link);
};
